import React, {Fragment, useEffect, useLayoutEffect} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useNavigationType} from "react-router";
import {
	fetchDetailPageScroll,
	fetchVoucherInfo,
	updateVoucherInfoList
} from "redux/slices/sales/salesSlice";

import {getPaymentTypeName, getServiceTypeColor, getServiceTypeName} from "utils/define";
import {getCommaNumber} from "utils/format";

import Filter from "components/ui/Filter";
import Observer from "components/ui/Observer";
import BottomBranch from "components/ui/popup/BottomBranch";



/**
 * [이용권 종류별 매출 목록]
 */
 
export const DetailList = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();

	const {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
		dataList,
		pageState
	} = useSelector(state => state.sales.voucherInfo);
	const partnerInfo = useSelector(state => state.partner);

	useLayoutEffect(() => {
		dispatch(fetchDetailPageScroll("restore"));
	}, []);

	useEffect(() => {
		const isUpdate = (
			!dataList || navigationType != "POP" || (
				searchPartner != dataList.searchInfo.searchPartner ||
				searchBranch != dataList.searchInfo.searchBranch ||
				searchDate != dataList.searchInfo.searchDate ||
				searchPeriodType != dataList.searchInfo.searchPeriodType ||
				searchFilter != dataList.searchInfo.searchFilter
			)
		);
		if(searchDate && searchPeriodType && isUpdate) {
			if(pageState != undefined) {
				dispatch(updateVoucherInfoList(false));
			}
		}
	}, [searchPartner, searchBranch, searchDate, searchPeriodType, searchFilter]);

	const eventHandler = {
		update : function() {
			dispatch(updateVoucherInfoList(true));
		},
		detail : (orderType, sequence, serviceType) => {
			navigate("/sales/" + orderType + "/payment/" + sequence, {
				state : {serviceType : serviceType}
			});
		},
		changeFilter : (name, value) => {
			dispatch(fetchVoucherInfo({
				searchFilter : value
			}));
		},
		changeBranch : (branch) => {
			dispatch(fetchVoucherInfo({
				searchBranch : branch,
			}));
		}
	};

	const render = () => {
		const getPaymentList = () => {
			let li = ((dataList || {}).paymentList || []).map(item => {
				const orderState = (item.orderState == "CANCELLED") ? "cancel" : (item.paymentKind == "REFUND") ? "refund" : "";
				const getSummary = () => {
					const datetime = new Date(item.paymentDatetime).format("sm. sd. sw · hh:MM");
					const memberName = item.memberName || "-";
					return (
						<Fragment>
							<span>{datetime}</span>
							<span>{memberName}</span>
						</Fragment>
					);
				};
				const getPaymentType = () => {
					const paymentTypeName = getPaymentTypeName(item.paymentType);
					const paymentKind = (orderState == "refund") ? "환불" : (item.orderState == "CANCELLED") ? "취소" : "결제";
					return paymentTypeName + " " + paymentKind;
				};
				const sequence = item.seqOrderPayment || item.seqRefundInfo;
				const orderType = (item.seqRefundInfo) ? "refund" : "order";
				const orderName = (item.paymentClassification == "TRANSFER") ? "양도 수수료" : (item.orderName || "").recoverTag();
				const serviceTypeName = getServiceTypeName(item.serviceType);
				const serviceTypeColor = getServiceTypeColor(item.serviceType);
				return (
					<li key={orderType + "-" + sequence} className={orderState}>
						<a onClick={() => {eventHandler.detail(orderType, sequence, item.serviceType)}}>
							<div className="left">
								<h5>{serviceTypeName}</h5>
								<h4>{orderName || "-"}</h4>
								<h5>{getSummary()}</h5>
							</div>
							<div className="right">
								<h6>&nbsp;</h6>
								<h4>{getCommaNumber(item.paymentAmount)}원</h4>
								<h5>{getPaymentType()}</h5>
							</div>
						</a>
					</li>
				)
			});
			if(!li.length && pageState != undefined) {
				li = <li className="empty">검색 결과가 없습니다.</li>
			}
			return (<ul className="color">{li}</ul>);
		};

		const filterList = [{
			label : "전체",
			value : "",
		}, {
			label : "개인레슨",
			value : "APPOINTMENT"
		}, {
			label : "그룹수업",
			value : "CLASS"
		}, {
			label : "시설이용",
			value : "PLACE"
		}, {
			label : "옵션이용",
			value : "OPTION"
		}, {
			label : "패키지",
			value : "PACKAGE"
		}];

		return (
			<Wrapper>
				<Filter
					title="이용권 종류 선택" value={searchFilter}
					options={filterList} onChange={eventHandler.changeFilter}
					isSticky={true}
				/>
				<div className="list">
					{getPaymentList()}
				</div>
				<Observer isActive={pageState} isLoading={true} onVisible={eventHandler.update} />
				<BottomBranch searchBranch={searchBranch} onChange={eventHandler.changeBranch} />
			</Wrapper>
		);
	};
	return render();
};

const Wrapper = styled.div`
.list								{padding:0 24px}
.list li + li						{border-top:1px solid var(--lightBorder)}
.list li.empty						{padding:20px 0; border:none; text-align:center; opacity:0.66}
.list a								{display:flex; align-items:center; justify-content:space-between; padding:25px 0}
.list h4							{margin:5px 0 7px; font-size:1rem; font-weight:500}
.list h5							{font-size:var(--13px); color:var(--gray40)}
.list h6							{font-size:var(--12px); color:#7783ad}
.list h5 span + span:before			{content:"|"; margin:0 0.5em; color:var(--gray); opacity:0.5}

.list .right						{padding-left:10px; text-align:right}
.list .right h4						{white-space:nowrap; font-size:var(--18px); font-weight:600; color:var(--blue)}
.list li.cancel .right h4 			{text-decoration:line-through; color:var(--gray40)}
.list li.refund .right h4			{color:var(--red)}
.list li.refund .right h4:before	{content:""}
`;

export default DetailList;